interface Card {
  title: string;
  description?: string;
  imageUrl?: string;
  link?: string;
}

interface CardGridProps {
  cards?: Card[];
}

export function CardGridBlock({ props }: { props: CardGridProps }) {
  const cards = props.cards ?? [];
  if (cards.length === 0) return null;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {cards.map((card, i) => {
        const inner = (
          <div className="bg-white border border-zinc-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow h-full flex flex-col">
            {card.imageUrl && (
              <img src={card.imageUrl} alt={card.title} className="w-full h-40 object-cover" />
            )}
            <div className="p-4 flex flex-col flex-1">
              <h3 className="font-semibold text-zinc-900 text-sm">{card.title}</h3>
              {card.description && (
                <p className="text-xs text-zinc-500 mt-1 flex-1">{card.description}</p>
              )}
              {card.link && (
                <span className="mt-3 text-xs font-medium text-[var(--color-primary)] hover:underline">
                  Learn more →
                </span>
              )}
            </div>
          </div>
        );
        return card.link ? (
          <a key={i} href={card.link} className="block h-full">
            {inner}
          </a>
        ) : (
          <div key={i} className="h-full">
            {inner}
          </div>
        );
      })}
    </div>
  );
}
